// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/context/auth-context'
import AppLoader from '@/components/AppLoader'

// Gates admin-only routes. Assumes RequireAuth already ensured a signed-in,
// provisioned user; here we additionally require org-admin (or operator) rank
// — `isAdmin` is derived from the role claim. Non-admins bounce to the dashboard.
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAdmin, loading } = useAuth()

  if (loading) return <AppLoader />
  if (!isAdmin) return <Navigate to="/dashboard" replace />
  return <>{children}</>
}
